import { useEffect, useState } from "react";

import { ApiService, CaseEMRDetails } from "pwapi";

import { CaseAdminDetail } from "shared/reducers/admin/adminCaseReducer";

import DjangoLink from "components/DjangoLink";
import Spinner from "components/Spinner";

const MANUAL_EMRS = {
  manual: { emr: "Manual" },
  ezderm: { emr: "EZDerm" },
};

const EmrHeaderDetails = ({ adminCase }: { adminCase: CaseAdminDetail }) => {
  const [details, setDetails] = useState<CaseEMRDetails | null>(
    adminCase.is_manually_accessioned
      ? MANUAL_EMRS.manual
      : adminCase.patient?.clinic?.ezderm_enabled
      ? MANUAL_EMRS.ezderm
      : null
  );

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!details && adminCase.id) {
      setLoading(true);
      ApiService.emrDetailsAdminCase({ id: adminCase.id })
        .then((emrDetails) => {
          setDetails(emrDetails);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [
    adminCase.id,
    adminCase.is_manually_accessioned,
    adminCase.patient?.clinic?.ezderm_enabled,
    details,
  ]);

  return !details?.emr && !loading ? null : details?.emr ? (
    <span className="header__displayMessage">
      Case has been{" "}
      {details.emr === "Manual"
        ? "manually accessioned"
        : `ordered from ${details.emr}`}
      {details.admin_url && (
        <DjangoLink
          route={details.admin_url}
          title="order message django"
          removeAdminKey
        />
      )}
    </span>
  ) : (
    <Spinner />
  );
};

export default EmrHeaderDetails;
